/* eslint-disable */
import React, { Component } from 'react'

class ErrorBoundary extends Component {
    constructor(props:any){
        super(props)
        this.state = { error: null, errorInfo: null }
    }

    componentDidCatch(error:any, info:any){
        this.setState({ error: error, errorInfo: info })
        window.location.reload();
    }

    render() {
        // @ts-ignore
        if(this.state.errorInfo){
            return (
                <div className="error-boundary">
                    <summary>Something went wrong</summary>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {/*// @ts-ignore*/}
                        { this.state.error && this.state.error.toString() }
                        {/*// @ts-ignore*/}
                        { this.state.errorInfo.componentStack }
                    </details>
                </div>
            )
        }
        // @ts-ignore
        return this.props.children
    }
}

export default ErrorBoundary;
